export type MentionSegment =
  | { type: 'text'; content: string }
  | {
      type: 'mention';
      content: string;
      entityType: 'user' | 'team';
      entityId: string;
    };

const MENTION_REGEX = /@\[([^\]]+)\]\((user|team):([^)]+)\)/g;

export function parseMentionMarkers(title: string): MentionSegment[] {
  const segments: MentionSegment[] = [];
  let lastIndex = 0;

  for (const match of title.matchAll(MENTION_REGEX)) {
    const matchStart = match.index ?? 0;
    if (matchStart > lastIndex) {
      segments.push({
        type: 'text',
        content: title.slice(lastIndex, matchStart),
      });
    }

    segments.push({
      type: 'mention',
      content: match[1] ?? '',
      entityType: (match[2] ?? 'user') as 'user' | 'team',
      entityId: match[3] ?? '',
    });

    lastIndex = matchStart + match[0].length;
  }

  if (lastIndex < title.length) {
    segments.push({ type: 'text', content: title.slice(lastIndex) });
  }

  return segments;
}

export function stripMentionMarkers(title: string): string {
  return title.replace(MENTION_REGEX, '@$1');
}
